import { Message, MessageContent } from '../models/message.model';

export const MESSAGE_TYPE_TITLE_KEYS: Record<string, string> = {
  service_package_created: 'messages.types.service_package_created',
  service_package_renewed: 'messages.types.service_package_renewed',
  service_package_updated: 'messages.types.service_package_updated',
  service_package_removed: 'messages.types.service_package_removed',
};

export const MESSAGE_CHANGE_FIELD_LABELS: Record<string, string> = {
  type: 'service_packages.col_type',
  value: 'service_packages.col_value',
  amount: 'service_packages.col_amount',
  start: 'service_packages.col_start',
  finish: 'service_packages.col_finish',
};

export function messageTitleKey(type: string): string {
  return MESSAGE_TYPE_TITLE_KEYS[type] ?? 'messages.types.unknown';
}

export function messageFieldLabel(field: string): string {
  return MESSAGE_CHANGE_FIELD_LABELS[field] ?? field;
}

export function messageChangesList(
  content: MessageContent,
): { field: string; from: unknown; to: unknown }[] {
  return Object.entries(content.changes ?? {}).map(([field, change]) => ({
    field,
    from: change.from,
    to: change.to,
  }));
}

const SNAPSHOT_FIELD_ORDER = Object.keys(MESSAGE_CHANGE_FIELD_LABELS);

export function messageSnapshotList(
  content: MessageContent,
): { field: string; value: unknown }[] {
  const snapshot = content.snapshot ?? {};
  const orderedFields = [
    ...SNAPSHOT_FIELD_ORDER.filter((field) => field in snapshot),
    ...Object.keys(snapshot).filter(
      (field) => !SNAPSHOT_FIELD_ORDER.includes(field),
    ),
  ];

  return orderedFields.map((field) => ({ field, value: snapshot[field] }));
}

export function messageTitleParams(message: Message): { id: number | string } {
  return { id: message.content.servicePackageId ?? '-' };
}
